import { mergeCompanyUpdate, registerModuleCatalog } from '../../util/entitlements';

export const SET_KEYS = "SET_KEYS";

/**
 * Shallow-merge `data` into `state.user`. `company` REPLACES the stored company
 * — to store a company WRITE response use `setCompanyFromUpdate` below, so the
 * entitlements survive. `moduleCatalog` is the server's module catalog from
 * the company session payload; it is also registered for the legacy helpers
 * whose signatures take no catalog (`getGateMeta(key)`, `getNextPreset(null, company)`).
 */
export function setKeys(data) {
  return async function (dispatch) {
    if (data && data.moduleCatalog) registerModuleCatalog(data.moduleCatalog);
    return dispatch({
      type: SET_KEYS,
      data: data,
    });
  };
}

/**
 * Store a company returned by a write (`PUT /companies/:id`, a settings save)
 * over the current one with `mergeCompanyUpdate`: fields from the response win,
 * and `entitlements` are kept from the stored company when the response does
 * not carry them. The stored company is read at dispatch time, never from a
 * render closure, so two quick saves cannot resurrect a stale company.
 */
export function setCompanyFromUpdate(updatedCompany) {
  return async function (dispatch, getState) {
    const previous = getState()?.user?.company;
    return dispatch({
      type: SET_KEYS,
      data: { company: mergeCompanyUpdate(previous, updatedCompany) },
    });
  };
}
